import * as React from "react";
var SvgIconMedium = function SvgIconMedium(props) {
  return /*#__PURE__*/React.createElement("svg", props);
};
export default SvgIconMedium;